import {
  Component,
  ViewChild,
  EventEmitter,
  Input,
  OnInit,
} from "@angular/core";
import { ModalComponent } from "../../../components/modal/modal.component";
import { Subject } from "rxjs/Subject";
import { TopLevelFieldMapping } from "../../../models/top-level-field-mapping.model";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import * as _ from "underscore";
import { DataType } from "../../../models/data-type.model";
import { Tag } from "../../../models/tag.model";
import Utils from "../../../services/utils";
import { TagService } from "../../../services/tag.service";
import { DataService } from "../../../services/data.service";

@Component({
  selector: "lowy-search-tags-modal",
  template: `
    <lowy-modal #modal>
      <div class="form">
        <div class="headline">Select Search Tags</div>
        <div class="subheading">Limit by search tag.</div>
        <div class="seperator"></div>

        <label class="big"></label>

        <div class="full-mat-line">
          <lowy-dropdown
            #tagTypeDropdown
            [label]="null"
            [fullWidth]="true"
            [placeholder]="'Tag type'"
            (add)="selectedTagTypeChange($event)"
            [data]="tagTypes"
            [singleItemSelection]="true"
          ></lowy-dropdown>
        </div>

        <div class="full-mat-line" [ngSwitch]="selectedTagType">
          <lowy-dropdown
            #searchTagDropdown
            [label]="null"
            [fullWidth]="true"
            [placeholder]="'Search tag'"
            (add)="addTags($event)"
            [data]="filteredSearchTags"
            [singleItemSelection]="false"
          ></lowy-dropdown>
        </div>

        <div class="seperator"></div>
        <div class="button-row">
          <span (click)="cancel()">cancel</span>
          <span (click)="save()">save</span>
        </div>
      </div>

      <mat-chip-list>
        <mat-chip *ngFor="let tag of searchTagsToAdd" class="search-tag"
          >{{ tag.name
          }}<i class="material-icons" (click)="deleteTag(tag)"
            >cancel</i
          ></mat-chip
        >
      </mat-chip-list>
    </lowy-modal>
  `,
  styles: [
    `
      .seperator {
        margin-bottom: 15px;
      }
    `,
  ],
})
export class EditSearchTagsComponent implements OnInit {
  @ViewChild("modal") modal: ModalComponent;

  @ViewChild("tagTypeDropdown") tagTypeDropdown: DropdownComponent;

  selectedTagType: DataType;
  filteredSearchTags: Tag[];
  allSearchTags: Tag[];
  searchTagsToAdd: Tag[];
  tagTypes: DataType[];

  public saveTagsEventEmitter: Subject<boolean>;

  constructor(
    private tagService: TagService,
    private dataService: DataService
  ) {
    this.saveTagsEventEmitter = new Subject();
  }

  async ngOnInit() {
    const allDataTypes = await this.dataService.getDataTypes();
    this.tagTypes = _.filter(allDataTypes, (dataType) => dataType.taggable);
    this.allSearchTags = await this.tagService.getTags();
  }

  public open() {
    this.modal.open();
    this.searchTagsToAdd = [];
  }

  save() {
    this.saveTagsEventEmitter.next();
    this.modal.close();
  }

  cancel() {
    this.modal.close();
  }

  public async selectedTagTypeChange(tagType: DataType) {
    await Utils.sleep();
    this.selectedTagType = tagType;
    this.filteredSearchTags = _.filter(
      this.allSearchTags,
      (tag) =>
        this.selectedTagType &&
        tag.dataTypeId === this.selectedTagType.dataTypeId
    );
  }

  public async addTags(tags: Tag[]) {
    for (let i = 0; i < tags.length; i++) {
      const tagForDisplay = JSON.parse(JSON.stringify(tags[i]));
      tagForDisplay.name =
        Utils.capitalizeFirstLetter(this.selectedTagType.abbr) +
        ": " +
        tagForDisplay.name;
      this.searchTagsToAdd.push(tagForDisplay);
    }
    this.selectedTagType = null;
    this.tagTypeDropdown.clearFilter();
    // this.updateTagList();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/search/search-modals/edit-search-tags-modal.component.ts